import { api, uploadForm } from '../lib/api.js';

export type CustomerRow = { id: string; priorityCode: string; name: string; classification: string | null; subClassification: string | null; isActive: boolean; contactCount: number; projectCount: number; createdAt: string };
export type LastImport = { fileName: string; uploadedAt: string; uploadedByName: string | null; rowCount: number; createdCount: number; updatedCount: number } | null;
export type ImportResult = {
  created: number; updated: number; total: number; skipped: number;
  mapping: Record<string, number>;
  // null = the file had no status column, so activity was not touched.
  samples: { priorityCode: string; name: string; classification: string | null; subClassification: string | null; isActive: boolean | null }[];
};
export type ContactRow = { id: string; name: string; email: string; phone: string | null; isActive: boolean; lastLoginAt: string | null };
export type AddContactResult = { id: string; tempPassword: string; emailed: boolean };

export type SlaRow = { severity: string; responseHours: number; resolutionHours: number };

export const customersApi = {
  list: () => api<CustomerRow[]>('/api/customers'),
  getSla: (id: string) => api<SlaRow[]>(`/api/customers/${id}/sla`),
  setSla: (id: string, severity: string, responseHours: number, resolutionHours: number) =>
    api<{ ok: true }>(`/api/customers/${id}/sla`, { method: 'POST', body: { severity, responseHours, resolutionHours } }),
  create: (priorityCode: string, name: string) => api<{ id: string }>('/api/customers', { method: 'POST', body: { priorityCode, name } }),
  setActive: (id: string, isActive: boolean) => api<{ ok: true }>(`/api/customers/${id}/active`, { method: 'PATCH', body: { isActive } }),
  contacts: (id: string) => api<ContactRow[]>(`/api/customers/${id}/contacts`),
  addContact: (id: string, body: { name: string; email: string; phone?: string }) =>
    api<AddContactResult>(`/api/customers/${id}/contacts`, { method: 'POST', body }),
  resetPassword: (contactId: string) => api<{ tempPassword: string; emailed: boolean }>(`/api/customers/contacts/${contactId}/reset-password`, { method: 'POST' }),
  setContactActive: (contactId: string, isActive: boolean) => api<{ ok: true }>(`/api/customers/contacts/${contactId}/active`, { method: 'PATCH', body: { isActive } }),
  lastImport: () => api<LastImport>('/api/customers/last-import'),
  importCsv: async (file: File): Promise<ImportResult> => {
    const fd = new FormData();
    fd.append('file', file);
    return uploadForm<ImportResult>('/api/customers/import', fd, 'POST',
      { fallbackMessage: 'שגיאה בהעלאת הקובץ' });
  },
};
